import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgAsyncGuiRef } from '../../../../async-gui-ref';
import { SgAsyncGuiDialogContainer } from './container.component';
import { SgAsyncGuiDialogPlugin } from './plugin';

@NgModule({
  imports: [CommonModule],
  declarations: [SgAsyncGuiDialogContainer],
})
export class SgAsyncGuiDialogPluginModule {
  static readonly PLUGIN = SgAsyncGuiDialogPlugin;
}
